import React from "react";
import { motion } from "framer-motion";
import { FaShieldAlt, FaUsers, FaClock, FaRobot } from "react-icons/fa";

const advantages = [
  {
    icon: <FaShieldAlt size={36} className="text-dark" />,
    title: "Crédibilité & professionnalisme",
    description: "Un site bien conçu renforce la confiance.",
  },
  {
    icon: <FaUsers size={36} className="text-dark" />,
    title: "Acquisition de clients",
    description: "Attirez plus de prospects grâce au SEO & au design optimisé.",
  },
  {
    icon: <FaClock size={36} className="text-dark" />,
    title: "Disponibilité 24/7",
    description:
      "Vos clients trouvent vos infos même en dehors des heures d’ouverture.",
  },
  {
    icon: <FaRobot size={36} className="text-dark" />,
    title: "Automatisation & efficacité",
    description: "Formulaires de contact, FAQ interactive…",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.5, ease: "easeOut" },
  }),
};

const Advantages = () => {
  return (
    <div className="container-fluid py-5 white-color black-bg">
      <div className="container">
        <h1 className="text-center mb-4">
          Pourquoi Avoir un Site Web est Essentiel pour Votre Entreprise ?
        </h1>
        <h3 className="text-center mb-5">
          Un site web, c’est votre meilleur commercial, 24h/24, 7j/7.
        </h3>
        <div className="row mb-4">
          {advantages.map((advantage, index) => (
            <motion.div
              key={index}
              className="col-md-6 col-lg-3 mb-4"
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              custom={index}
            >
              <div className="advantage-card card rounded-4 text-center text-white p-4">
                <div className="d-flex justify-content-center align-items-center">
                  <div className="mb-3 p-2 bg-light rounded-circle">
                    {advantage.icon}
                  </div>
                </div>
                <h6 className="fw-bold">{advantage.title}</h6>
                <p className="text-white">{advantage.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="text-center">
          <h5 className="mb-4">
            Pourquoi attendre ? Faites passer votre business au niveau supérieur
            !
          </h5>
          <motion.button
            className="btn btn-primary rounded-pill px-4 py-2 "
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <a
              target="blank"
              className="text-decoration-none white-color"
              href="https://tally.so/r/m6vN5o"
            >
              Réservez un appel découverte
            </a>
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Advantages;
